import { useState } from 'react';

// Generate a consistent color based on company name
const getColorFromName = (name) => {
  const colors = [
    { bg: 'bg-teal-500', text: 'text-white' },
    { bg: 'bg-blue-500', text: 'text-white' },
    { bg: 'bg-purple-500', text: 'text-white' },
    { bg: 'bg-amber-500', text: 'text-white' },
    { bg: 'bg-rose-500', text: 'text-white' },
    { bg: 'bg-emerald-500', text: 'text-white' },
    { bg: 'bg-indigo-500', text: 'text-white' },
    { bg: 'bg-cyan-500', text: 'text-white' },
    { bg: 'bg-orange-500', text: 'text-white' },
    { bg: 'bg-pink-500', text: 'text-white' },
  ];
  
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  return colors[Math.abs(hash) % colors.length];
};

// Get initials from company name (max 2 characters)
const getInitials = (name) => {
  if (!name) return 'CO';
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};

const CompanyAvatar = ({ 
  name, 
  logoUrl, 
  size = 'md',
  className = '',
  showFallback = true 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const sizeClasses = {
    sm: 'w-10 h-10 text-xs',
    md: 'w-16 h-16 text-base',
    lg: 'w-20 h-20 text-lg',
    xl: 'w-24 h-24 text-xl',
  };
  
  const colors = getColorFromName(name || 'Company');
  const initials = getInitials(name);
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  
  // Show fallback if no logo URL or image failed to load
  const shouldShowFallback = !logoUrl || imageError;
  
  if (shouldShowFallback && showFallback) {
    return (
      <div 
        className={`${sizeClass} ${colors.bg} ${colors.text} rounded-lg flex items-center justify-center font-semibold shadow-sm ${className}`}
        title={name}
      >
        {initials}
      </div>
    );
  }
  
  return (
    <div className={`${sizeClass} rounded-lg overflow-hidden border border-slate-200 ${className}`}>
      {!imageLoaded && !imageError && (
        <div className={`${sizeClass} ${colors.bg} ${colors.text} flex items-center justify-center font-semibold animate-pulse`}>
          {initials}
        </div>
      )}
      <img
        src={logoUrl}
        alt={name}
        className={`w-full h-full object-cover ${imageLoaded ? 'block' : 'hidden'}`}
        onLoad={() => setImageLoaded(true)}
        onError={() => setImageError(true)}
      />
    </div>
  );
};

export default CompanyAvatar;
